import React from 'react';
import { useSelector } from 'react-redux';
import SubscriptionContainer from '@src/containers/Subscription';
import SubscriptionSMSContainer from '@src/containers/Subscription/SubscriptionSMS';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import { SMS_IDENTITY_PROVIDER } from '@src/constants';
import PageNotFound from './PageNotFound';

const Subscription = () => {
  const user = useSelector((state) => state.auth.user);
  const { getFeatureValue } = useFeatureFlags();
  const { identityProvider } = useSelector((state) => state.auth.user);
  const isSMSUser = Object.values(SMS_IDENTITY_PROVIDER).includes(
    identityProvider,
  );
  const showSubscriptionPage = getFeatureValue(FEATURE_KEYS.SUBSCRIPTION, {
    userId: user.id,
    email: user.email,
    phoneNumber: user.phoneNumber,
  });

  const renderSubscriptionPage = () => {
    if (isSMSUser && showSubscriptionPage) {
      return <SubscriptionSMSContainer />;
    }

    if (!isSMSUser && showSubscriptionPage) {
      return <SubscriptionContainer />;
    }

    return <PageNotFound />;
  };

  return renderSubscriptionPage();
};

export default Subscription;
